"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.installApmPayloadScrubber = installApmPayloadScrubber;
var _apmRum = require("@elastic/apm-rum");
var _constants = require("../constants");
var _scrubApmPayload = require("./scrubApmPayload");
var PATCHED_FLAG = '__difyLeadGenScrubberPatched';
var INSTANCE_FLAG = '__difyLeadGenScrubberAdded';

// apm-rum doesn't export FilterFn. Our filter's `undefined` return is a valid drop (applyFilters bails on falsy).

/**
 * Registers `scrubApmPayload` on every Elastic APM client for this service.
 *
 * `@wsb/advanced-apm-rum` (1.2.1) exposes no filter option and creates a NEW `ApmBase` on every
 * `captureError`, and `@wsb/modal-loader` creates its own client in the loader bundle. All of them
 * go through `new ApmBase(...).init(config)`, so we wrap `ApmBase.prototype.init` and add the filter
 * for clients whose `serviceName` is ours — host apps sharing this apm-rum copy are left untouched.
 *
 * Must be CALLED (not just imported — package.json `sideEffects` would tree-shake a bare import)
 * from both entry points before any client is created. Idempotent.
 *
 * Not covered: the `apm` singleton's `init`, which @elastic/apm-rum binds at module load. Nothing
 * here uses it. Remove this patch once @wsb/advanced-apm-rum / @wsb/modal-loader accept filters.
 */
function installApmPayloadScrubber() {
  var proto = _apmRum.ApmBase === null || _apmRum.ApmBase === void 0 ? void 0 : _apmRum.ApmBase.prototype;
  if (!proto || typeof proto.init !== 'function' || proto[PATCHED_FLAG]) return;
  var originalInit = proto.init;
  proto.init = function patchedInit(config) {
    if ((config === null || config === void 0 ? void 0 : config.serviceName) === _constants.APP_NAMESPACE && !this[INSTANCE_FLAG]) {
      try {
        // addFilter works pre-init (the config service is created lazily) and on disabled clients.
        this.addFilter(_scrubApmPayload.scrubApmPayload);
        Object.defineProperty(this, INSTANCE_FLAG, {
          value: true
        });
      } catch (_unused) {
        // Never block APM initialization.
      }
    }
    return originalInit.call(this, config);
  };
  Object.defineProperty(proto, PATCHED_FLAG, {
    value: true
  });
}